import React from 'react';

function TrophySilver() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20.094" viewBox="0 0 20 20.094">
      <path
        d="M30.262,33.876h.527a5.947,5.947,0,0,0,4.158,3.353v1.953H33.491a.814.814,0,0,0-.814.814v1.068h-.727a.519.519,0,0,0-.525.53V44.37a.519.519,0,0,0,.519.519h8.5a.519.519,0,0,0,.527-.519V41.594a.519.519,0,0,0-.519-.519h-.734V40.008a.814.814,0,0,0-.814-.814H37.452V37.23a5.947,5.947,0,0,0,4.158-3.353h.527A4.061,4.061,0,0,0,46.2,29.813V27.346a.651.651,0,0,0-.651-.651h-3.41V25.447a.651.651,0,0,0-.651-.651H30.911a.651.651,0,0,0-.651.651V26.7H26.85a.651.651,0,0,0-.651.651v2.466a4.061,4.061,0,0,0,4.063,4.063ZM42.138,31.43V28.752h2.005v1.061a2.008,2.008,0,0,1-2.005,2.005h-.013C42.132,31.691,42.138,31.561,42.138,31.43ZM28.257,28.748h2.005V31.43a3.851,3.851,0,0,0,.013.389h-.013a2.008,2.008,0,0,1-2.005-2.005Z"
        transform="translate(-26.199 -24.796)"
        fill="#d2d3d5"
      />
    </svg>
  );
}

export default TrophySilver;
